import { Environment } from "../interfaces/environment";

/**Get the current environment */
export const getEnvironment = (): Environment =>
  process?.env.NODE_ENV === "production" ? "production" : "development";
